/**
 * Colors defined by UX team
 * Don't use them directly, only through staticColors
 */
export const figmaColors = {
    black: '#000000',
    white: '#FFFFFF',
    grey6: '#2B3A3D',
    grey5: '#5F6C6E',
    grey4: '#A3ABAC',
    grey3: '#C6CACB',
    grey2: '#DDE1E1',
    grey1: '#EFF0F0',
    grey0: '#F7F8F8',
    green50: '#E8F5E9',
    green100: '#C8E6C9',
    green200: '#A5D6A7',
    green300: '#81C784',
    green400: '#66BB6A',
    green500: '#4CAF50',
    green600: '#43A047',
    green700: '#388E3C',
    green800: '#2E7D32',
    green900: '#1B5E20',
    orange50: '#FFF3E0',
    orange100: '#FFE0B2',
    orange200: '#FFCC80',
    orange300: '#FFB74D',
    orange400: '#FFA726',
    orange500: '#FF9800',
    orange600: '#FB8C00',
    orange700: '#F57C00',
    orange800: '#EF6C00',
    orange900: '#E65100',
    red50: '#FFEBEE',
    red100: '#FFCDD2',
    red200: '#EF9A9A',
    red300: '#E57373',
    red400: '#EF5350',
    red500: '#F44336',
    red600: '#E53935',
    red700: '#D32F2F',
    red800: '#C62828',
    red900: '#B71C1C',
    sky50: '#E3F2FD',
    sky100: '#BBDEFB',
    sky200: '#90CAF9',
    sky300: '#64B5F6',
    sky400: '#42A5F5',
    sky500: '#2196F3',
    sky600: '#1E88E5',
    sky700: '#1976D2',
    sky800: '#1565C0',
    sky900: '#0D47A1',
    turquoise50: '#D8F4F7',
    turquoise100: '#B1E9EF',
    turquoise200: '#7EDAE4',
    turquoise300: '#4BCBD9',
    turquoise400: '#25C0D1',
    turquoise500: '#00A7B8',
    turquoise600: '#0085A2',
    turquoise700: '#006588',
    turquoise800: '#00486D',
    turquoise900: '#00345A',
};
